import React from 'react';
import {Button, Row, Col, Glyphicon, FormControl} from 'react-bootstrap';
import AscComponent from '../../components/AscComponent';
import CommonTable from '../Elements/Table/CommonTable';
import * as GlobalConst from '../../components/AscConstants';
import OperatorGroupModal from './OperatorGroupModal';

export default class OperatorGroup extends AscComponent {
    constructor(props) {
        super(props)
        this.state = {
            columns: this.getColumnsData(),
            data: [],
            filtered: [],
            pages: null,
            loading: false,

            show: false,
            modalType: null,

            // selects
            companySelect: [],
            departmentSelect: [],
            floorSelect: [],
            operatorSelect: [],

            // data
            id: '',
            company_id: '',
            company_name: '',
            department_id: '',
            department_name: '',
            department_prefix: '',
            floor_id: '',
            floor_name: '',
            floor_flg: false,
            group_name: '',
            operator_ids: [],
            operatorGroupNameDuplicateFlag: false
        }
    }

    getColumnsData() {
        let itemArr = []

        // ID
        itemArr.push({
            Header: this.props.langText.Body.Id,
            accessor: 'id',
            filterable: false,
            width: this.props.boardWidth.id
        });

        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            itemArr.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: 'cm13_departments.cm12_companies.company_name',
                Filter: () => <FormControl placeholder={this.props.langText.Body.ForwardMatch} onChange={e => this.onFilterChange(e.target.value, 'cm13_departments.cm12_companies.company_name')} />
            });
        }
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
            itemArr.push({
                Header: this.props.langText.Body.DepartmentName,
                accessor: 'cm13_departments.department_name',
                Filter: () => <FormControl placeholder={this.props.langText.Body.ForwardMatch} onChange={e => this.onFilterChange(e.target.value, 'cm13_departments.department_name')} />
            });
        }
        if ((this.props.systemParameters.SYSTEM_FLOOR_FLG === 'Y' &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system)) ||
            (this.props.userInfo.floor_flg && 
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department))) {
            itemArr.push({
                Header: this.props.langText.Body.FloorName,
                accessor: 'cm13_departments.floor_name',
                Filter: () => <FormControl placeholder={this.props.langText.Body.ForwardMatch} onChange={e => this.onFilterChange(e.target.value, 'cm13_departments.floor_name')} />
            });
        }

        itemArr.push({
            Header: this.props.langText.Body.GroupName,
            accessor: 'operator_group_name',
            Filter: () => <FormControl placeholder={this.props.langText.Body.ForwardMatch} onChange={e => this.onFilterChange(e.target.value, 'operator_group_name')} />
        });

        itemArr.push({
            Header: this.props.langText.Body.BusinessOperatorCount,
            accessor: 'OperatorCount',
            filterable: false
        });

        itemArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            width: this.props.boardWidth.smedium,
            Cell: data => {
                let rowData = []
                if (this.props.currentPermission.edit) {
                    rowData.push(
                        <Button 
                            key={0} 
                            bsSize='xsmall' 
                            className='control-button' 
                            onClick={this.modalShow('update', data.row._original)}
                        >
                            <Glyphicon glyph='pencil'/>
                        </Button>
                    );
                } else {
                    rowData.push(
                        <Button 
                            key={0} 
                            bsSize='xsmall' 
                            className='control-button' 
                            onClick={this.modalShow('read', data.row._original)}
                        >
                            <Glyphicon glyph='eye-open'/>
                        </Button>
                    );
                }
                if (this.props.currentPermission.create) {
                    rowData.push(
                        <Button 
                            key={1} 
                            bsSize='xsmall' 
                            className='control-button' 
                            onClick={this.modalShow('copy', data.row._original)}
                        >
                            <Glyphicon glyph='copy'/>
                        </Button>
                    );
                }
                if (this.props.currentPermission.delete) {
                    rowData.push(
                        <Button 
                            key={2} 
                            bsSize='xsmall' 
                            className='control-button' 
                            onClick={this.modalShow('delete', data.row._original)}
                        >
                            <Glyphicon glyph='minus'/>
                        </Button>
                    );
                }
                return (rowData);
            }
        });

        return itemArr
    }

    modalShow = (modalType, param) => async event => {
        event.preventDefault();

        let setData = {
            id: param && param.id 
                ? param.id 
                : '',
            company_id: param && param.cm13_departments && param.cm13_departments.cm12_companies 
                && param.cm13_departments.cm12_companies.id 
                ? param.cm13_departments.cm12_companies.id 
                : '',
            company_name: param && param.cm13_departments && param.cm13_departments.cm12_companies 
                && param.cm13_departments.cm12_companies.company_name 
                ? param.cm13_departments.cm12_companies.company_name 
                : '',
            floor_flg: param && param.cm13_departments && param.cm13_departments.cm12_companies 
                && param.cm13_departments.cm12_companies.floor_flg 
                ? param.cm13_departments.cm12_companies.floor_flg === 'Y' 
                : null,
            department_id: param && param.cm13_departments && param.cm13_departments.id 
                ? param.cm13_departments.id 
                : '',
            department_name: param && param.cm13_departments && param.cm13_departments.department_name 
                ? param.cm13_departments.department_name 
                : '',
            department_prefix: param && param.cm13_departments && param.cm13_departments.department_prefix 
                ? param.cm13_departments.department_prefix 
                : '',
            floor_id: param && param.cm13_departments && param.cm13_departments.id 
                ? param.cm13_departments.id 
                : '',
            floor_name: param && param.cm13_departments && param.cm13_departments.floor_name 
                ? param.cm13_departments.floor_name 
                : '',
            group_name: param && param.operator_group_name && modalType !== "copy"
                ? param.operator_group_name 
                : '',
            operator_ids: param && param.cm16_operators && param.cm16_operators.length > 0 
                ? param.cm16_operators.map(row => row.id) 
                : []
        };

        if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
            setData.company_id = this.props.userInfo.company_id;
            setData.company_name = this.props.userInfo.company_name;
            setData.floor_flg = this.props.userInfo.floor_flg;
        }
        if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department)) {
            if (this.props.userInfo.floor_flg) {
                setData.department_id = this.props.userInfo.parent_department_id;
                setData.department_name = this.props.userInfo.parent_department_name;
                setData.department_prefix = this.props.userInfo.department_prefix;
            } else {
                setData.department_id = this.props.userInfo.department_id;
                setData.department_name = this.props.userInfo.department_name;
            }
        }
        if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)) {
            setData.floor_id = this.props.userInfo.department_id;
            setData.floor_name = this.props.userInfo.floor_name;
        }

        try {
            await this.getCompanySelect();
            await this.getDepartmentSelect(setData);
            await this.getFloorSelect(setData);
            await this.getOperatorSelect(setData);

            if (modalType === "copy" && setData.floor_flg && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
                const department_id = this.state.departmentSelect.find(row => row.label === setData.department_name)?.value;
                if (department_id) setData.department_id = department_id;
            }
            
            this.setState({
                ...setData,
                operatorGroupNameDuplicateFlag: false
            });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }

        this.setState({ show: true, modalType });
    }

    getCompanySelect = async () => {
        try {
            let res = await this.ascAxios('post', `Common/companySelect`, { container: this.reactContainerPath });
            this.setState({ companySelect: res.data });
        } catch (err) { 
            throw err; 
        }
    }

    getDepartmentSelect = async ({ company_id, floor_flg }) => {
        if (!company_id) return;
        try {
            let res = await this.ascAxios('post', `Common/departmentSelect`, { container: this.reactContainerPath, company_id, floor_flg });
            
            this.setState({ departmentSelect: res.data });
        } catch (err) { 
            throw err; 
        }
    }

    getFloorSelect = async ({ company_id, department_prefix, floor_flg }) => {
        if (!company_id || !department_prefix || !floor_flg) return;
        try {
            let res = await this.ascAxios('post', `Common/floorSelect`, { container: this.reactContainerPath, company_id, department_prefix });
            this.setState({ floorSelect: res.data });
        } catch (err) { 
            throw err;
        }
    }

    getOperatorSelect = async ({ company_id, department_id, floor_id, floor_flg }) => {
        try {
            const cm13_id = floor_flg ? floor_id : department_id;
            if (!company_id || !cm13_id) {
                this.setState({ operatorSelect: [], operator_ids: [] });
                return;
            }
            let res = await this.ascAxios('post', `${this.reactContainerPath}/getOperatorByDepartmentOrFloorId`, { company_id, cm13_id });
            const options = res.data.map(row => ({ value: row.value, label: row.label }));
            this.setState({ operatorSelect: options });
        } catch (err) { 
            throw err; 
        }
    }

    async onSelectChange(event, param) {
        super.onSelectChange(event, param);
        const value = (event && event.value) ? event.value : "";
        const floor_flg = (event && event.floor_flg) ? event.floor_flg === 'Y' : this.state.floor_flg;
        const department_prefix = (event && event.department_prefix) ? event.department_prefix : this.state.department_prefix;
        try {
            switch (param) {
                case 'company_id':
                    this.setState({
                        department_id: '',
                        floor_id: '',
                        floor_flg,
                        operator_ids: [],
                        operatorSelect: []
                    });
                    await this.getDepartmentSelect({ company_id: value, floor_flg });
                    await this.checkOperatorGroupNameDuplicate();
                    break;
                case 'department_id':
                    let state_body = {
                        operator_ids: [],
                        operatorSelect: []
                    };
                    if (this.state.floor_flg) {
                        state_body.floor_id = '';
                        this.setState(state_body);
                        await this.getFloorSelect({ company_id: this.state.company_id, department_prefix, floor_flg: this.state.floor_flg });
                    } else {
                        this.setState(state_body);
                        await this.getOperatorSelect({ company_id: this.state.company_id, department_id: value, floor_flg: this.state.floor_flg });
                    }
                    break;
                case 'floor_id':
                    this.setState({ operator_ids: [], operatorSelect: [] });
                    await this.getOperatorSelect({ company_id: this.state.company_id, floor_id: value, floor_flg: this.state.floor_flg });
                    break;
                default:
                    break;
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    // グループ名の重複チェック（会社内、更新時は自身を除外）
    checkOperatorGroupNameDuplicate = async () => {
        const { 
            company_id, 
            group_name, 
            id, 
            modalType 
        } = this.state;

        if (!group_name || !company_id) {
            this.setState({ operatorGroupNameDuplicateFlag: false });
            return;
        }

        try {
            const body = { company_id, group_name };
            if (modalType === 'update' && id) body.id = id;
            let res = await this.ascAxios('post', `${this.reactContainerPath}/checkDuplicateOperatorGroupName`, body);
            this.setState({ operatorGroupNameDuplicateFlag: !!(res.data && res.data.isDuplicate) });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    onClickHandle = modalType => async event => {
        let { id, company_id, department_id, floor_id, group_name, operator_ids, floor_flg } = this.state
        try {
            switch (modalType) {
                case 'insert':
                case 'copy':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/insert`, {
                        company_id,
                        department_id: floor_flg ? floor_id : department_id,
                        group_name,
                        operator_ids: (operator_ids || []).map(o => o.value || o)
                    });
                    alert(this.props.langText.Message.DataInsertSuccess);
                    this.reactTableRefresh();
                    break;
                case 'update':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/update`, {
                        id,
                        company_id,
                        department_id: floor_flg ? floor_id : department_id,
                        group_name,
                        operator_ids: (operator_ids || []).map(o => o.value || o)
                    });
                    alert(this.props.langText.Message.DataUpdateSuccess);
                    this.reactTableRefresh();
                    break;
                case 'delete':
                    if (window.confirm(this.props.langText.Message.User_Delete_Check)) {
                        this.blockUI();
                        await this.ascAxios('post', `${this.reactContainerPath}/delete`, { id });
                        alert(this.props.langText.Message.DataDeleteSuccess);
                        this.reactTableRefresh();
                    }
                    break;
                default:
                    throw 'ModalTypeError';
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
        this.setState({ show: false });
    }

    validationHandle = (param) => {
        let {
            company_id,
            department_id,
            floor_id,
            floor_flg,
            group_name,
            operator_ids,
            operatorGroupNameDuplicateFlag
        } = this.state;

        let nowState = null;

        switch (param) {
            case 'company_id':
            case 'department_id':
            case 'floor_id':
                nowState = this.state[param] ? null : 'error';
                break;
            case 'group_name':
                nowState = (this.state[param] && !operatorGroupNameDuplicateFlag) ? null : 'error';
                break;

            case 'operator_ids':
                nowState = this.state[param] && this.state[param].length > 0 ? null : 'error';
                break;
            
            case 'insert':
            case 'copy':
            case 'update':
                nowState = (
                    company_id &&
                    department_id &&
                    group_name &&
                    !operatorGroupNameDuplicateFlag &&
                    (Array.isArray(operator_ids) && operator_ids.length > 0)
                );
                if (floor_flg) nowState = nowState && !!floor_id;
                break;

            case 'delete':
                nowState = (!!company_id && !!department_id);
                if (floor_flg) nowState = nowState && !!floor_id;
                break;

            default:
                nowState = true;
                break;
        }

        return nowState;
    }

    render() {
        return (
            <div className='OperatorGroup'>
                <Row>
                    {this.props.currentPermission.create && (
                        <Col xs={12} md={12}>
                            <Button id='og-insert' className='table-button' bsStyle='default' bsSize='sm' onClick={this.modalShow('insert')}>
                                {this.props.langText.Body.InsertTitle}
                            </Button>
                        </Col>
                    )}
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{ height: this.props.tableHeight }}
                            manual='manual'
                            columns={this.state.columns}
                            data={this.state.data}
                            pages={this.state.pages}
                            loading={this.state.loading}
                            defaultSorted={[{ id: 'id', desc: true }]}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            filterable={true}
                            previousText={this.props.langText.Table.PreviousText}
                            nextText={this.props.langText.Table.NextText}
                            loadingText={this.props.langText.Table.LoadingText}
                            noDataText={this.props.langText.Table.NoDataText}
                            rowsText={this.props.langText.Table.RowsText}
                        />
                    </Col>
                </Row>
                {this.state.show && (
                    <OperatorGroupModal
                        getScopeGreaterEqual={this.getScopeGreaterEqual}
                        floor_flg={this.state.floor_flg}
                        state={this.state}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        charaLimit={this.props.charaLimit}
                        onClick={this.onClickHandle}
                        onTextChange_Limit={this.onTextChange_Limit}
                        onSelectChange={this.onSelectChange}
                        validationHandle={this.validationHandle}
                        checkOperatorGroupNameDuplicate={this.checkOperatorGroupNameDuplicate}
                    />
                )}
            </div>
        );
    }
}


